import { useProgram } from '@entities/programs';
import type React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ModerationStatusViewer } from '@features/common/SmallCardStatus/ModerationStatus/index.tsx';
import { ModalRecommend, useProgramLoader, useProgramVideos } from '@features/programs';
import { usePlatformSettings } from '@shared/hooks';
import { LargeHeader } from '@shared/ui';
import { Loader, ModalLarge } from 'library/components/common';
import { VideoProgram } from 'library/components/programs';
import * as st from './styles.module.scss';

export const ProgramModal: React.FC = () => {
  const { id, code, clientId, tabCode } = useParams<{ [x: string]: string }>();
  const programId = Number(id);
  const navigate = useNavigate();

  const { moderation } = usePlatformSettings();

  const { isLoading } = useProgramLoader(programId);
  const { program } = useProgram(programId);
  const { isAuthor } = useProgramVideos(program);

  const onClose = () => {
    navigate(`/clients/${code}/${clientId}/${tabCode}/recommend`);
  };

  return (
    <ModalLarge onRequestClose={onClose} title="Программа" disableHeader isOpen>
      {!isLoading && program && (
        <div className={st.program}>
          <LargeHeader
            title="Рекомендовать программу"
            onClose={onClose}
            right={
              <>
                {program && program && isAuthor && moderation ? (
                  <ModerationStatusViewer
                    moderationStatus={program.moderation_status}
                    isPublished={program.publication?.is_published || false}
                  />
                ) : (
                  // program?.program?.is_payed && <RentalStatus program={program.program} />
                  <></>
                )}
              </>
            }
          />

          <section className={st.program__content}>
            <VideoProgram
              programId={programId}
              onClose={onClose}
              isModal={true}
              program={program}
            />
          </section>
        </div>
      )}

      {isLoading && <Loader />}
      <ModalRecommend />
    </ModalLarge>
  );
};
